import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ChevronRight } from "lucide-react";
import { Input } from "../../../components/ui/input/SimpleInput";
import ButtonV2 from "../../../components/ui/button/v2";

interface EvidenceUrlModalV2Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (url: string) => void;
  initialUrl?: string;
}

const EvidenceUrlModalV2: React.FC<EvidenceUrlModalV2Props> = ({
  isOpen,
  onClose,
  onSave,
  initialUrl = "",
}) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (isOpen) {
      setUrl(initialUrl);
    }
  }, [isOpen, initialUrl]);

  const handleSave = () => {
    onSave(url.trim());
  };

  if (!isOpen) return null;

  const modalContent = (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto relative z-[10000]">
        <div className="space-y-4 p-6">
          <div className="flex justify-between items-center pb-0">
            <h2 className="text-xl font-semibold">Upload Evidence</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              ✕
            </button>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              URL
            </label>
            <Input
              type="text"
              placeholder="Enter Evidence URL"
              value={url}
              className="px-3"
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>
        </div>

        <div className="px-6 pb-6 flex gap-4 w-full">
          <ButtonV2
            disabled={!url.trim()}
            className="w-full"
            variant="outline-primary"
            onClick={handleSave}
            suffix={<ChevronRight className="w-4 h-4" />}
          >
            Save & Proceed
          </ButtonV2>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default EvidenceUrlModalV2;
